import styled from 'styled-components';

const TextMuted = styled.p`
  forn-size: 0.9375rem;
  color: var( --color-secondary-text);
`;

export default TextMuted;
